<!-- 由 suu 创建于 2022-01-18 星期二 -->
<!-- 营养评估方案 列表 -->
<template>
  <div class="recipe-list">
    <!-- 营养评估方案列表 -->
    <div>
      <div class="menu-item" v-for="(item, index) in menuList" :key="index">
        <div class="menu-padding" @click="jumpQuestion(index)">
          <i class="iconfont icon-yingyangshigongju"></i>
          <div class="item-center">
            <span class="item-title">
              {{ item.plan_type }}日营养评估方案{{
                item.version == 1 ? '2.0' : '3.0'
              }}
            </span>
            <span class="item-time">购买时间: {{ item.add_time }}</span>
          </div>
          <div>
            <span
              v-if="item.success && item.plan_flag == '3'"
              class="item-status item-status-create"
              >已生成</span
            >
            <span
              v-else-if="!item.success && item.plan_flag == '3'"
              class="item-status item-status-submit"
              >已提交</span
            >
            <span v-else class="item-status item-status-use">待使用</span>
          </div>
          <van-icon name="arrow" class="icon-you" />
        </div>
      </div>
    </div>
    <!-- 没有营养评估方案时显示 -->
    <div class="not-menulist" v-if="isloaded && !menuList.length">
      <div class="qrcode-container">
        <span>您还没有专属营养方案，可以联系小助理购买哦～</span>
        <image
          class="qrcode-img"
          mode="widthFix"
          src="https://cdnvue.gymcity.com.cn/uploads/11597e4d15ce3adfa965fbf554ed1961.png"
        ></image>
        <span>截图识别二维码，添加小助理微信</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'recipe-list',

  components: {},

  props: {},

  data() {
    return {
      isloaded: false,
      isEmpty: true,
      menuList: [],
      qrcodeImg: ''
    }
  },

  computed: {},

  watch: {},

  created() {
    this.getNutritionProgrammeData()
  },

  mounted() {},

  destroyed() {},

  methods: {
    getNutritionProgrammeData() {
      this.$toast.loading('加载中···')
      this.$http
        .getApp('member/AppCamp/posterListNew', {})
        .then((res) => {
          this.$toast.clear()
          res = res.data
          if (res.code == 200) {
            let data = res.data
            data = data.map((item, index) => {
              // 方案后台生成时间
              let times = item.que_time && item.que_time.replace(/-/g, '/')
              // 根据当地时间补充偏移量
              if (
                times &&
                item.que_time &&
                this.bjTimeToLocal(times).getTime() <= new Date().getTime()
              ) {
                item.success = true
              } else {
                item.success = false
              }
              return item
            })
            console.log(data)

            this.menuList = data

            this.isloaded = true
          }
        })
        .catch((err) => {
          this.$toast.clear()
          this.isloaded = true
        })
    },
    //指定的北京时间信息转成世界各地时间
    bjTimeToLocal(bj_str) {
      let local = new Date(bj_str)
      let bj_zone = 8
      var d = new Date()
      var tmpHours = local.getHours()
      //算得时区
      var time_zone = -d.getTimezoneOffset() / 60
      if (time_zone > bj_zone) {
        local.setHours(tmpHours + Math.abs(time_zone - bj_zone))
      } else {
        local.setHours(tmpHours - Math.abs(bj_zone - time_zone))
      }
      return local
    },
    //世界各地的某个时间转为北京时间
    changeBeijingTime(currentDate) {
      let bj_zone = 8
      //获得当前运行环境时间
      var d = new Date()
      var tmpHours = currentDate.getHours()
      alert(tmpHours)
      //算得时区
      var time_zone = -d.getTimezoneOffset() / 60
      if (time_zone > bj_zone) {
        currentDate.setHours(tmpHours - Math.abs(time_zone - bj_zone))
      } else {
        currentDate.setHours(tmpHours + Math.abs(bj_zone - time_zone))
      }
      return currentDate
    },
    /* 跳转到问卷调查 */
    jumpQuestion(index) {
      let status = parseInt(this.menuList[index].plan_flag)
      let success = this.menuList[index].success
      let phone = this.menuList[index].phone || ''
      let number = this.menuList[index].q_num || ''
      let id = this.menuList[index].id || ''
      let version = this.menuList[index].version
      let s_from = this.menuList[index].s_from || ''
      sessionStorage.setItem('nutritionInfo', this.menuList[index])
      if (version == 1) {
        // 版本1
        switch (status) {
          case 3:
            if (success) {
              wx.navigateTo({
                url: '/pages/questionResult/questionResult?id=' + id
              })
            } else {
              wx.navigateTo({
                url: '/pages/quetionSubmitSuccess/quetionSubmitSuccess?type=back'
              })
            }
            break
          default:
            wx.navigateTo({
              url:
                '/pages/questionPoster/questionPoster?phone=' +
                phone +
                '&q_num=' +
                number +
                '&id=' +
                id
            })
        }
      } else if (version == 2) {
        // 版本2
        switch (status) {
          case 3:
            if (success) {
              // 已生成方案
              this.$router.push(`/recipe-result?id=${id}&s_from=${s_from}`)
            } else {
              // 提交问卷结果
              wx.navigateTo({
                url: '/package-recipe/pages/questionnaire/submitStatus/index?type=1'
              })
            }
            break
          default:
            // 问卷
            this.$router.push(`/recipe-question?id=${id}`)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
.recipe-list {
  width: 100%;
  min-height: 100vh;
  .not-menulist {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .qrcode-container {
    text-align: center;
    padding: vw(40) vw(60);
    box-sizing: border-box;
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    left: 50%;
    top: 10%;
    border-radius: vw(20);
    transform: translate(-50%);
    width: vw(600);
    background-color: #fff;
    animation: qrcodeScale 0.3s ease-in-out;
  }

  @keyframes qrcodeScale {
    0% {
      transform: translate(-50%) scale(0.6);
    }

    100% {
      transform: translate(-50%) scale(1);
    }
  }

  .qrcode-img {
    width: vw(340);
    height: vw(340);
    margin: vw(20) auto;
  }

  .item-icon {
    width: vw(30);
    margin-right: vw(30);
  }

  .menu-item {
    padding: vw(0) vw(44);
    box-sizing: border-box;
  }

  .menu-padding {
    height: vw(150);
    padding: vw(30) vw(0);
    display: flex;
    align-items: center;
    box-sizing: border-box;
    border-bottom: 1px solid #f1f1f1;
  }
  .icon-yingyangshigongju {
    font-size: vw(34);
    color: #6384e8;
    margin-right: vw(32);
  }
  .item-center {
    flex-shrink: 0;
    display: flex;
    overflow: hidden;
    flex-direction: column;
    flex: 1;
  }
  .item-title {
    font-size: vw(30);
    color: #000;
    margin-bottom: vw(12);
  }

  .item-time {
    font-size: vw(24);
    color: rgba(0, 0, 0, 0.5);
  }

  .item-status {
    padding: vw(0) vw(20);
    display: block;
    text-align: center;
    height: vw(40);
    line-height: vw(40);
    margin: vw(0) vw(40);
    border-radius: vw(20);
    font-size: vw(20);
  }

  .item-status-submit {
    background-color: #f1f1f1;
    color: #999;
  }

  .item-status-create {
    font-size: vw(24);
    color: #979da5;
  }

  .item-status-use {
    height: vw(44);
    line-height: vw(44);
    background-image: linear-gradient(90deg, #618cf7 0%, #3461e5 100%);
    border-radius: vw(22);
    font-size: vw(22);
    color: #fff;
  }
  .icon-you {
    font-size: vw(22);
    color: #666;
  }
}
</style>
